import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
  SalesPlanService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "design-wise-so-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./DesignWiseSOReport.html",
})
export class DesignWiseSOReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("data") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter = {
    fin_id: 3,
    season: 0,
    season_id: 3,
    design_no: "",
    opmin: "",
    opmax: "",
    oqmin: "",
    oqmax: "",
    search: "",
  };
  page = {
    limit: 99999,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };
  finyearList = [];
  agentList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("season") season;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  gridOptions: any;
  exceldata: any;
  reportName = "design_no";
  reportType = "DesignWise";
  filterExpand = false;
  seasonfinList: any;
  filterData: any = {
    fin_id: 3,
    orderDir: "Asc",
    orderColumn: "design_no",
    genLedid: "",
    //company_id: 0
  };
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private salesplanservice: SalesPlanService,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  printConfig: any = {
    title: "Design Wise Sales Order report",
    columns: [],
    rows: [],
  };

  loadParams() {
    if (this.params && this.params.data) {
      if (this.params.type === "color") {
        this.reportName = "design_id";
        this.reportType = "Design Color";
        this.filter.design_no = this.params.data.design_no;
        this.filter.season_id = this.params.data.season_id;
        this.title = this.reportType + " Report";
      } else {
        this.title = this.reportType + " Report";
        return;
      }
    }
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  ngOnInit(): void {
    this.LoadFinYearList();
    this.loadSeasonList();

    if (this.menu.param == "color") {
      this.reportName = "design_id";
      this.reportType = "Design Color";
    } else {
      this.reportName = "design_no";
      this.reportType = "Design Wise";
    }

    this.params;

    this.loadParams();
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    const colName = this.reportName == "design_no" ? "design_no" : "dispName";
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        type: "sno",
      },

      {
        name: "Design no",
        prop: colName,
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },

      {
        name: "Style",
        prop: "style",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },

      {
        name: "Type",
        prop: "type",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },

      {
        name: "F Qty",
        cellClass: "txtRight",
        prop: "fqty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
      {
        name: "H Qty",
        cellClass: "txtRight",
        prop: "hqty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
      {
        name: "Tot Qty",
        cellClass: "txtRight",
        prop: "totqty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
    ];
    if (colName == "dispName" || true) {
      this.columns.push({
        name: "Order %",
        cellClass: "txtRight",
        prop: "orderper",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      });
    }

    this.gridOptions = {
      columns: this.columns,
      loading: true,
    };
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    this.getPartySalesOrder();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  onPrevButClick() {
    this.reportName = "design_no";
    this.getColumns();
    this.getPartySalesOrder();
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getPartySalesOrder();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getPartySalesOrder();
  }

  getPartySalesOrder(): void {
    let params = {
      groupBy: this.reportName,
      fin_id: this.filter.fin_id,
      season_id: this.filter.season_id,
      search: this.filter.search,
      opmin: this.filter.opmin,
      oqmin: this.filter.oqmin,
      oqmax: this.filter.oqmax,
      opmax: this.filter.opmax,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      design_no: this.filter.design_no,
    };
    let that = this;
    this.isLoadMask = this.reportService
      .getDesignWiseReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;

        that.page.count = res.data.length;
        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.refreshData();
        that.exceldata = that.getData(that.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Design Wise Sales Order report",
          columns: that.columns,
          rows: that.gridOptions.data,
        };
        //  that.columns = res.columns;
      });
  }

  onCellClick(event) {
    let params = {
      groupBy: "design_id",
      fin_id: this.filter.fin_id,
      season_id: this.filter.season_id,
      search: this.filter.search,
      opmin: this.filter.opmin,
      oqmin: this.filter.oqmin,
      oqmax: this.filter.oqmax,
      opmax: this.filter.opmax,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      design_no: event.row.design_no,
    };
    if (params.design_no !== "Open Order") {
      let that = this;
      //this.store.dispatch(new commonActions.LoadAllParty(params));
      this.isLoadMask = this.reportService
        .getDesignWiseReport(params)
        .then(function (res: any) {
          that.loadingIndicator = false;
          //  that.dataList = res.data;
          that.reportName = "dispName";
          that.getColumns();
          that.page.count = res.data.length;
          that.gridOptions = {
            columns: that.columns,
            data: res.data,
            loading: false,
          };
        });
    } else {
      this.gridOptions = {
        columns: this.columns,
        data: [],
        loading: false,
      };
    }
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      fin_id: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getPartySalesOrder();
  }

  onRowSelected($event) {
    if (this.reportName !== "design_no") {
      return;
    }

    let data = Object.assign($event.selected[0]);
    // data['fin_id'] = this.filter.fin_id;
    data["fin_id"] = this.filter.fin_id;
    data["season_id"] = this.filter.season_id;
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "DesignWiseSOReport",
        type: "color",
        mode: "View",
        data: data,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  displayFn(comboType: string, id: number) {
    let list: any[];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      that.filter.fin_id = fitem["fin_id"];
      return fitem["finyear"];
    }
    return "";
  }
  seasonFromFn(comboType: string, id: number) {
    let list: any= [];
    let that = this;
    if (comboType == "season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }
  loadSeasonList() {
    let that = this;
    this.combo.seasonCombo().then((res: any) => {
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
      this.getPartySalesOrder();
    });
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.loadSeasonList();
      window["finyear"] = that.finyearCtrl;
      that.finyearList = res.data;
      let fin = res.data[0]["fin_id"];
      if (that.params && that.params.data) {
        fin = that.params.data.fin_id;
      }
      that.filter.fin_id = fin;
      that.filterData.fin_id = fin;
      that.finyearCtrl.setValue(fin);
      that.onSelectFinyear(res.data[0].fin_id);
      // this.getPartySalesOrder();
    });
  }
  onSelectFinyear(id) {
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.filter["inv_from_date"] = "";
    this.filter["inv_to_date"] = "";
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  LoadAgentList() {
    let that = this;
    this.salesplanservice.getAgentList({}).then((res: any) => {
      that.agentList = res.data;
    });
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      rowtype: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/DesignWiseSOReport/DesignWiseSOReport.ts